(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('assistant', {
                parent: 'entity',
                url: '/assistant',
                data: {
                    authorities: [],
                    pageTitle: 'Assistants'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/assistant/list/assistant.html',
                        controller: 'AssistantController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Assistant'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_ASSISTANT];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_ASSISTANT, access);
                }]
            });
    }
})();
